import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { SunMark } from "@/components/Sun";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="max-w-3xl mx-auto px-4 py-32 text-center">
      <Seo title="Page Not Found | Indigenous Security Services" description="The page you requested could not be found. Browse our security services and locations across Canada." path="/404/" />
      <div className="flex justify-center mb-6"><SunMark size={64} /></div>
      <h1 className="text-4xl font-bold font-display text-slate-50 mb-4">404 — Page Not Found</h1>
      <p className="text-slate-400 mb-8">The page you are looking for does not exist. Explore our security services or coverage areas instead.</p>
      <div className="flex justify-center gap-3">
        <Link to="/" data-testid="not-found-home-link" className="rounded-full bg-amber-500 px-6 py-3 text-sm font-bold text-slate-950 hover:bg-amber-400 transition-colors">Back to Home</Link>
        <Link to="/services/" data-testid="not-found-services-link" className="rounded-full border border-slate-600 px-6 py-3 text-sm font-semibold text-slate-100 hover:border-amber-500/60 transition-colors">View Services</Link>
      </div>
    </div>
  );
}
